<template>
  <div id="main-nav" class="bg-light">
    <nav class="navbar navbar-expand-lg navbar-light bg-info" style="background-color:#17a2b852!important;">
      <humburger class="mt-auto p-0"  v-if="$auth.check(['admin'])" :open="adminNavIsActive" @toggle="toggleAdminNav"></humburger>
      <router-link class="navbar-brand ml-4" :to="{ name: 'home'}">Сфера БН</router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" v-if="$auth.token()">
            <a href="#" class="nav-link" @click.prevent="$auth.logout()">Выйти</a>
          </li>
          <li class="nav-item" v-else>
            <router-link class="nav-link" :to="{ name: 'login'}">Логин</router-link>
          </li>
        </ul>
      </div>
    </nav>
    <div id="admin-nav" v-show="adminNavIsActive" class="bg-light py-3">
      <div class="container-fluid">
        <div class="row" v-for="section in adminNav">
          <div class="col-md-12">
            <legend>{{section.Title}}</legend>
          </div>
          <div class="col-sm-6 col-md-4 col-lg-4 col-xl-3" v-for="group in section.Groups">
            <ul class="list-unstyled">
              <li v-for="link in group.Links">
                <router-link :to="{ name: link.RouteName, params: link.Params}">{{link.Name}}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import _ from 'lodash';
import * as $ from 'jquery';
import humburger from '@/admin/components/humburger.vue';

export default {
  data() {
    return {
      adminNavIsActive: false,
      adminNavMaster: [
        {
          Title: 'Основные настройки',
          Groups: [
            {
              Title: '',
              Links: [
                { Name: 'Типы оплаты', RouteName: 'payment-type', Params: {} },
                { Name: 'Статусы заказа', RouteName: 'order-status', Params: {} },
                { Name: 'Роуты', RouteName: 'route', Params: {} },
                { Name: 'Настройка расходов', RouteName: 'expense-settings', Params: {} },
              ],
            },
            {
              Title: '',
              Links: [
                { Name: 'Пользователи панели', RouteName: 'panel-user', Params: {} },
                { Name: 'Группы пользователей', RouteName: 'role', Params: {} },
              ],
            },
          ],
        },
        {
          Title: 'Партнеры',
          Groups: [
            {
              Title: '',
              Links: [
                { Name: 'Группы клиентов', RouteName: 'customer-group', Params: {} },
                { Name: 'Заказы партнеров', RouteName: 'partner-order', Params: {} },
              ],
            },
          ],
        },
      ],
    };
  },
  computed: {
    adminNav() {
      const nav = Object.assign({}, this.adminNavMaster);
      _.findLast(nav, i => i.Title === 'Партнеры')
        .Groups
        .push(
          { Links: this.adminNavPartners },
          { Links: this.adminNavPartnerPriceListName },
          { Links: this.adminNavPartnerTours },
          { Links: this.adminNavPartnerPrices },
        );
      return nav;
    },
    adminNavPartners() {
      return _.map(this.$root.partnerGroups, value => ({ Name: `Список партнеров ${value.Name}`, RouteName: 'partner-list', Params: { partnerGroupId: value.Id } }));
    },
    adminNavPartnerPriceListName() {
      return _.map(this.$root.partnerGroups, value => ({ Name: `Названия прайсов партнеров ${value.Name}`, RouteName: 'price-list', Params: { id: value.Id } }));
    },
    adminNavPartnerTours() {
      return _.map(this.$root.partnerGroups, value => ({ Name: `Объезды партнера ${value.Name}`, RouteName: 'tour', Params: { id: value.Id } }));
    },
    adminNavPartnerPrices() {
      const res = _.map(this.$root.partnerGroups, value => _.map((this.$root.paymentTypes), paymentType => ({
        Name: `Цены партнера ${value.Name} ${paymentType.Name}`,
        RouteName: 'price',
        Params: { partnerGroupId: value.Id, paymentTypeId: paymentType.Id },
      })));
      // console.log('1this.$root.paymentTypes', this.$root.paymentTypes)
      return _.flatten(res);
    },
  },
  components: {
    humburger,
  },
  async mounted() {
    $('#admin-nav')
      .on('click', 'a', (event) => {
        this.adminNavIsActive = false;
      });
  },
  methods: {
    toggleAdminNav(isActive) {
      this.adminNavIsActive = isActive;
    },
  },
};
</script>
<style lang="scss">
#admin-nav {
  z-index: 1500;
  position: absolute;
  width: 100%;
  a {
    color: rgba(0,0,0,.9);
  }
}

.hamburger-inner, .hamburger-inner:after, .hamburger-inner:before {
  background-color: #4a4a4a;
}

.smooth-enter-active, .smooth-leave-active {
  transition: opacity .1s;
}

.smooth-enter, .smooth-leave-to {
  opacity: 0
}
</style>
